import useFlags from 'hooks/useFlags'
import styled, { css } from 'styled-components'
import Button from '../Button'

export const Container = styled.header`
  padding: 0 ${({ theme }) => theme.old.sizes.sidesMargin.large};
  min-height: ${({ theme }) => theme.old.sizes.header};
  width: 100%;
  position: ${({ $isCreators }) => $isCreators ? 'unset' : 'fixed'};
  z-index: 10;

  ${({ theme, $isCreators }) => {
    
    const { isCommunitySectionEnabled } = useFlags()
    const headerHeight = isCommunitySectionEnabled ? '250%' : '150%'

    if ($isCreators) {
      return css`
        color: black;
        background-color: white;
        box-shadow: 0 2px 3px rgba(0,0,0, .1);
      `

    } else {
      const darkenBg = css`
        box-shadow: 0 0 30px 35px rgba(0,0,0, .85);
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 1) 50%,
          rgba(0, 0, 0, .9) 80%,
          rgba(0, 0, 0, .8) 100%
        );
      `

      const normalBg = css`
        box-shadow: 0 0 35px 20px rgba(0,0,0, .6);
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, .93) 55%,
          rgba(0, 0, 0, .75) 80%,
          rgba(0, 0, 0, .6) 100%
        );
      `

      return css`
        color: white;
        
        ::before {
          content: '';
          position: absolute;
          left: -50px;
          top: -50px;
          width: 150%;
          height: ${headerHeight};
          z-index: -1;
          filter: blur(10px);
          pointer-events: none;
          transition: all 200ms;
          ${props => props.isDarken ? darkenBg : normalBg}

          ${theme.old.breakpoints.isMobile} {
            height: ${headerHeight};
          }
        }
      `
    }

  }}

  ${({ theme }) => theme.old.breakpoints.isTab} {
    padding: 0 ${({ theme }) => theme.old.sizes.sidesMargin.small};
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    gap: 10px;
  }

`

export const Nav = styled.nav`
  display: flex;
  height: 40px;
  padding-bottom: 13px; // to align nav with flixx number
  align-items: flex-end;
  gap: 48px;
  flex-grow: 1;
`

export const BurgerBtn = styled(Button)`
  visibility: hidden;
  display: none;

  ${({ theme }) => theme.old.breakpoints.isTab} {
    visibility: visible;
    display: grid;
  }
`